import { apiFetch } from "./client";

export interface HireProposal {
  id: string;
  companyId: string;
  approvalId: string | null;
  proposedByAgentId: string | null;
  proposedByUserId: string | null;
  proposedName: string;
  proposedRole: string;
  proposedTitle: string | null;
  proposedReportsTo: string | null;
  hireTargetType: string;
  hireTargetConfig: Record<string, unknown> | null;
  justification: string | null;
  status: string;
  resultAgentId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ProposeHireResult {
  proposal: HireProposal;
  approval: Record<string, unknown>;
}

export interface ActivateHireResult {
  proposal: HireProposal;
  agent: Record<string, unknown>;
}

export interface CreateHireProposalInput {
  companyId: string;
  proposedByAgentId?: string | null;
  proposedByUserId?: string | null;
  proposedName: string;
  proposedRole?: string;
  proposedTitle?: string;
  proposedReportsTo?: string | null;
  hireTargetType: "existing_instance_subagent" | "new_azure_instance";
  hireTargetConfig?: Record<string, unknown>;
  justification?: string;
}

export const hiringApi = {
  list: (companyId: string) =>
    apiFetch<HireProposal[]>(`/hiring?companyId=${companyId}`),
  get: (id: string) =>
    apiFetch<HireProposal>(`/hiring/${id}`),
  propose: (data: CreateHireProposalInput) =>
    apiFetch<ProposeHireResult>("/hiring", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  submit: (id: string) =>
    apiFetch<HireProposal>(`/hiring/${id}/submit`, {
      method: "POST",
    }),
  activate: (id: string) =>
    apiFetch<ActivateHireResult>(`/hiring/${id}/activate`, {
      method: "POST",
    }),
};
